import compact from 'lodash/compact';
import get from 'lodash/get';

export const HEADER_OFFSET = 239;

// Venue->String
export const formatLocation = (venue) => {
  const name = get(venue, 'name', '');
  const city = get(venue, 'location.city', '');
  return city ? name + ', ' + city : name;
};

// {}->String
export const generateAddress = (location) => {
  return compact([
    location.streetAddress1,
    location.streetAddress2,
    location.streetAddress3,
    location.zip,
    location.city,
    location.state,
    location.country
  ]).join(', ');
};

export default { formatLocation, generateAddress, HEADER_OFFSET };



// WEBPACK FOOTER //
// ./frontend/react/components/edp/messages/messages_utils.js